export enum UserRole {
  SUPER_ADMIN = 'SUPER_ADMIN',
  ADMIN = 'ADMIN',
  USER = 'USER',
  CITIZEN = 'citizen',
  STAFF = 'STAFF',
  GGO = 'GGO',
  SYSTEM_USER='SYSTEM_USER',
  ORGANIZATION_STAFF='ORGANIZATION_STAFF',
  ORGANIZATION_ADMIN='ORGANIZATION_ADMIN'
}
